import RemoveCircle from '@material-ui/icons/RemoveCircle';
import React, { memo } from 'react';

export const RemoveCircleIcon = memo(
  ({ disabled }: Readonly<{ disabled: boolean }>) => (
    <RemoveCircle style={{ color: disabled ? 'lightgray' : 'red' }} />
  )
);

RemoveCircleIcon.displayName = 'RemoveCircleIcon';
